/**
 * 网站配置 操作封装
 */
import {WEBSITE_CONFIG_STORE_NAME} from '@/config/setting';

/**
 * 获取缓存的 网站配置
 */
export function getWebsiteConfig() {
    let config = localStorage.getItem(WEBSITE_CONFIG_STORE_NAME);
    if (!config) {
        config = sessionStorage.getItem(WEBSITE_CONFIG_STORE_NAME);
    }
    return JSON.parse(config);
}

/**
 * 缓存 网站配置
 * @param config 配置
 * @param remember 是否永久存储
 */
export function setWebsiteConfig(config, remember = false) {
    removeWebsiteConfig();
    if (Object.keys(config).length > 0) {
        if (remember) {
            localStorage.setItem(WEBSITE_CONFIG_STORE_NAME, JSON.stringify(config));
        } else {
            sessionStorage.setItem(WEBSITE_CONFIG_STORE_NAME, JSON.stringify(config));
        }
    }
}

/**
 * 移除 网站配置
 */
export function removeWebsiteConfig() {
    localStorage.removeItem(WEBSITE_CONFIG_STORE_NAME);
    sessionStorage.removeItem(WEBSITE_CONFIG_STORE_NAME);
}